/**
 * Maps an AssignedToExpression to a value valid for a new workflow entity
 * type, using the AssignedToExpression field-option lists of the old and new
 * entity types as the source of truth. Entity-specific owner expressions
 * (e.g. account manager for AbEntry, assigned-to for Lead) only appear in
 * their own entity type's option list, so the replacement is derived from the
 * set difference rather than hardcoded keys.
 */
export function normalizeAssignedToExpression(
  expression: string,
  oldOptions: string[],
  newOptions: string[],
): string {
  if (newOptions.includes(expression)) {
    return expression;
  }
  const entitySpecific = newOptions.filter(
    (option) => !oldOptions.includes(option),
  );
  if (entitySpecific.length === 0) {
    return expression;
  }
  return entitySpecific[0];
}
